import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeopleProfileReportsComponent } from './people-profile-reports.component';
import { VerificationStatusModule } from "../../components/verification-status/verification-status.module";
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { LoaderModule } from '../loader/loader.module';
import { ReportsTooltipDirective } from './reports-tooltip-directive/reports-tooltip-directive.directive';
import { CardsModule } from '@xref/xref-lib';

@NgModule({
  declarations: [PeopleProfileReportsComponent, ReportsTooltipDirective],
  imports: [
    CommonModule,
    RouterModule,
    VerificationStatusModule,
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
    LoaderModule,
    CardsModule
  ],
  exports: [
    PeopleProfileReportsComponent
  ],
})
export class PeopleProfileReportsModule { }
